import React, { Component } from "react";
import { connect } from "react-redux";
import { PageHeader, Row, Col, Select, Tag, Spin, message, Modal, Input, InputNumber, DatePicker, Alert, Timeline, Steps, Dropdown, Menu, Button, Upload, Form as FormAntd } from "antd";
import {
    ArrowLeftOutlined,
    ArrowRightOutlined,
    CheckCircleOutlined,
    StopOutlined,
    FilePdfOutlined,
    QrcodeOutlined,
    SaveOutlined,
    PlusOutlined,
    DeleteOutlined,
    DownloadOutlined,
    DownOutlined,
    TeamOutlined,
    SafetyCertificateOutlined,
    EditOutlined,
    CameraOutlined,
    EyeOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { FormItem, InputItem, SelectItem, TextAreaItem, DynamicCardForm, ButtonItem, ErrorItem, SelectEmpleadosItem } from "../../../../Components/Items";
import SelectDocumentoItem from "../../../../Components/SelectDocumentoItem";
import SelectActivoCMMS from "../componentes/SelectActivoCMMS";
import SelectorEstatusEquipo from "../componentes/SelectorEstatusEquipo";
import AnexosCMMS from "../componentes/AnexosCMMS";
import ModalPdfCMMS from "../componentes/ModalPdfCMMS";
import ModalEtiquetasCMMS from "../componentes/ModalEtiquetasCMMS";
import ModalReporteVisitaCMMS from "../componentes/ModalReporteVisitaCMMS";
import ModalFechasServicioCMMS from "../componentes/ModalFechasServicioCMMS";
import { cargarListasCMMS } from "../componentes/accionesPlanes";
import RutinaServicio, { avanceRutina } from "./RutinaServicio";
import PartesServicio from "./PartesServicio";
import ViaticosServicio from "./ViaticosServicio";
import ordenServicioCMMSPdf from "../../../../Pdf/cmms/ordenServicioCMMSPdf";
import { medirMarcaAgua } from "../../../../Pdf/cmms/comunCMMSPdf";
import CertificadosServicio from "./CertificadosServicio";
import { generarPdfCertificado } from "../Certificados/pdfCertificado";
import { cmmsPost, TIPOS_SERVICIO, estatusServicio, formatoFechaHora, minutosATexto, anexosAPayload, ORIGENES, ETIQUETAS_ANEXO } from "../cmmsComun";
import "../cmms.css";

const { Option } = Select;

const DOCUMENTOS = [
    { value: "Cotizacion", label: "Cotización" },
    { value: "Pedido", label: "Pedido" },
    { value: "Venta", label: "Venta" },
];

// Orden de Servicio por pasos (como en TINC): se avanza con los pasos de arriba o con
// Anterior / Siguiente, y se puede guardar en cualquier paso. Todos los pasos quedan montados
// (sólo se ocultan) para que el formulario conserve y valide todos los campos.
// Se abre con history.push("/panel/cmmsServicio", { id }) para editar, o { activoId } / { ticketId } / {}
// para uno nuevo con todo lo posible precargado.

// Paso en que vive cada campo del formulario (para llevar al usuario al campo con error).
// Por clave y no por numero, para que agregar u ocultar un paso no descuadre los demas.
const PASO_DE_CAMPO = {
    activoId: "general", tipoServicio: "general", estatus: "general", folioExterno: "general", referencia: "general",
    empleadoId: "general", empleadosApoyoIds: "general", fechaInicio: "general", fechaConclusion: "general", duracionTrasladoMin: "general", fechaProgramada: "general",
    lugar: "diagnostico", ubicacion: "diagnostico", area: "diagnostico", responsableCliente: "diagnostico", recepcionEstatus: "diagnostico", recepcionTexto: "diagnostico",
    entregaEstatus: "diagnostico", entregaTexto: "diagnostico", fallaReportada: "diagnostico", fallaEncontrada: "diagnostico", reporteTecnico: "diagnostico", notas: "diagnostico",
    anexos: "anexos", montoTotal: "anexos", aptoFacturacion: "anexos", fechaEnvioReporte: "anexos",
};

// Lo que manda este formulario al guardar, como estaba al abrir la Orden ("base" para juntar con lo
// que se cambie en la app mientras tanto). Lo que el web no edita (refacciones requeridas,
// proveedor) no va: asi el web nunca lo borra.
const CAMPOS_BASE_FUSION = [
    "activoId", "tipoServicio", "folioExterno", "referencia", "empleadoId", "empleadosApoyoIds", "fechaProgramada", "fechaInicio", "fechaConclusion",
    "duracionTrasladoMin", "lugar", "responsableCliente", "ubicacion", "area", "condicionesRecepcion", "condicionesEntrega", "fallaReportada",
    "fallaEncontrada", "reporteTecnico", "notas", "rutina", "partes", "viaticos", "documentos", "montoTotal", "aptoFacturacion", "fechaEnvioReporte",
];

class Servicio extends Component {
    formRef = React.createRef();
    accionPendiente = null;

    state = {
        loading: true,
        servicio: null, // documento guardado (null = nuevo)
        activoTexto: "",
        rutina: null,
        partes: [],
        viaticos: [],
        categoriasViatico: [],
        // Concluido: con el permiso "Editar servicios concluidos" se puede abrir la edicion completa.
        puedeEditarConcluido: false,
        edicionCompleta: false,
        documentos: [],
        rutinas: [],
        modalPdf: false,
        modalEtiqueta: false,
        modalVisita: false,
        pdfCertificado: null, // { _id, codigo }
        certificados: [],
        plantillasCertificado: [],
        cancelar: null,
        fechaInicio: null,
        fechaConclusion: null,
        // Al abrir una Orden en curso sin término se pregunta primero cuándo empezó y terminó.
        pedirFechas: false,
        ticketCodigo: "",
        // Se puede abrir en un paso (ej. desde el tablero, cuando al concluir falto algo).
        paso: this.props.location?.state?.paso || 0,
    };

    get id() {
        return this.state.servicio?._id || this.props.location?.state?.id || null;
    }

    get estatus() {
        return this.state.servicio?.estatus;
    }

    componentDidMount() {
        this.cargar();
    }

    cargar = async () => {
        this.setState({ loading: true });
        try {
            cargarListasCMMS(this.props).then((c) => this.setState({ categoriasViatico: c.categoriasViatico || [] }));
            const rRutinas = await cmmsPost(this.props, "selectRutinasCMMS", { valor: 1 });
            this.setState({ rutinas: rRutinas.data.success === 2 ? rRutinas.data.rutinas : [] });
            const st = this.props.location?.state || {};
            if (st.id) await this.consultar(st.id);
            else await this.preparar(st);
        } finally {
            this.setState({ loading: false });
        }
    };

    // Certificados del servicio (paso Certificados y Descargar ▾) y plantillas para uno nuevo.
    cargarCertificados = async (id = this.id) => {
        if (!id) return;
        try {
            const res = await cmmsPost(this.props, "certificadosServicioCMMS", { servicioId: id });
            if (res.data.success === 2) this.setState({ certificados: res.data.certificados, plantillasCertificado: res.data.plantillas });
        } catch (error) {
            console.log(error);
        }
    };

    consultar = async (id) => {
        this.cargarCertificados(id);
        const res = await cmmsPost(this.props, "datosServicioCMMS", { id });
        if (res.data.success !== 2) return message.error(res.data.message || "No se encontró el servicio");
        const s = res.data.servicio;
        this.aplicarAlFormulario(s);
        this.setState({
            servicio: s,
            activoTexto: s.activoTexto,
            rutina: s.rutina,
            partes: s.partes || [],
            viaticos: s.viaticos || [],
            puedeEditarConcluido: !!res.data.puedeEditarConcluido,
            edicionCompleta: false,
            documentos: s.documentos || [],
            ticketCodigo: s.ticketCodigo || "",
        });
        this.preguntarFechas(s);
    };

    // Una vez por pantalla: si la Orden está en curso y aún no tiene término, lo primero es la
    // fecha y hora de inicio y de término (casi siempre se captura después de hacer el servicio).
    preguntarFechas = (s) => {
        if (this.fechasPreguntadas || !s || Number(s.estatus) !== 2 || s.fechaConclusion) return;
        this.fechasPreguntadas = true;
        this.setState({ pedirFechas: true });
    };

    // Foto o archivo desde "Fotos ▾" (en cualquier paso): se agrega a los anexos del formulario con
    // su etiqueta, igual que en el paso Anexos, y se guarda con el servicio.
    agregarAnexo = (file, etiqueta) => {
        if (file.size / 1024 / 1024 >= 20) {
            message.error(`"${file.name}" pesa más de 20MB`);
            return Upload.LIST_IGNORE;
        }
        const nuevo = {
            uid: file.uid,
            name: file.name,
            nombre: file.name.replace(/\.[^.]+$/, ""),
            originFileObj: file,
            etiqueta,
            preview: /^image\//.test(file.type) ? URL.createObjectURL(file) : null,
        };
        const actuales = this.formRef.current?.getFieldValue("anexos") || [];
        this.formRef.current?.setFieldsValue({ anexos: [...actuales, nuevo] });
        // Un solo aviso aunque se elijan varias.
        this.anexosAgregados = (this.anexosAgregados || 0) + 1;
        clearTimeout(this.avisoAnexos);
        this.avisoAnexos = setTimeout(() => {
            message.success(`${this.anexosAgregados} archivo(s) de “${etiqueta}” agregado(s) a los anexos: se guardan con Guardar`);
            this.anexosAgregados = 0;
        }, 300);
        return false;
    };

    aceptarFechas = (inicio, termino) => {
        this.formRef.current?.setFieldsValue({ fechaInicio: inicio, fechaConclusion: termino || undefined });
        this.setState({ pedirFechas: false, fechaInicio: inicio.toISOString(), fechaConclusion: termino ? termino.toISOString() : null });
    };

    preparar = async ({ activoId, ticketId, tipoServicio, planId }) => {
        const res = await cmmsPost(this.props, "prepararServicioCMMS", { activoId, ticketId, tipoServicio, planId });
        if (res.data.success !== 2) {
            // El servicio calendarizado ya tiene su Orden de Servicio: se abre esa.
            if (res.data.servicioId) {
                message.info(res.data.message);
                this.props.history.replace("/panel/cmmsServicio", { id: res.data.servicioId });
                return this.consultar(res.data.servicioId);
            }
            return message.error(res.data.message || "No se pudo preparar el servicio");
        }
        const b = res.data.borrador;
        this.aplicarAlFormulario({ ...b, estatus: 2 });
        this.preguntarFechas({ ...b, estatus: 2 });
        this.setState({
            servicio: null,
            borrador: b,
            activoTexto: b.activoTexto || "",
            rutina: b.rutina,
            partes: b.partes || [],
            viaticos: this.state.viaticos || [],
            documentos: [],
            ticketCodigo: b.ticketCodigo || "",
        });
    };

    aplicarAlFormulario = (s) => {
        const f = (v) => (v ? moment(v) : undefined);
        this.formRef.current?.setFieldsValue({
            activoId: s.activoId || undefined,
            tipoServicio: s.tipoServicio,
            estatus: s.estatus === 1 ? 1 : 2,
            folioExterno: s.folioExterno,
            referencia: s.referencia,
            empleadoId: s.empleadoId || undefined,
            empleadosApoyoIds: s.empleadosApoyoIds || [],
            fechaProgramada: f(s.fechaProgramada),
            fechaInicio: f(s.fechaInicio),
            fechaConclusion: f(s.fechaConclusion),
            duracionTrasladoMin: s.duracionTrasladoMin,
            lugar: s.lugar,
            responsableCliente: s.responsableCliente,
            ubicacion: s.ubicacion,
            area: s.area,
            recepcionEstatus: s.condicionesRecepcion?.estatus || undefined,
            recepcionTexto: s.condicionesRecepcion?.texto,
            entregaEstatus: s.condicionesEntrega?.estatus || undefined,
            entregaTexto: s.condicionesEntrega?.texto,
            fallaReportada: s.fallaReportada,
            fallaEncontrada: s.fallaEncontrada,
            reporteTecnico: s.reporteTecnico,
            notas: s.notas,
            anexos: s.anexos || [],
            montoTotal: s.montoTotal,
            aptoFacturacion: s.aptoFacturacion ? moment(s.aptoFacturacion, "YYYY-MM") : undefined,
            fechaEnvioReporte: f(s.fechaEnvioReporte),
        });
        this.setState({ fechaInicio: s.fechaInicio || null, fechaConclusion: s.fechaConclusion || null });
    };

    // Elegir activo en un servicio nuevo: se vuelve a preparar (rutina, kit, cliente...).
    onChangeActivo = async (activoId) => {
        if (this.state.servicio || !activoId) return;
        const tipoServicio = this.formRef.current?.getFieldValue("tipoServicio");
        const ticketId = this.state.borrador?.ticketId;
        this.setState({ loading: true });
        try {
            await this.preparar({ activoId, ticketId, tipoServicio });
        } finally {
            this.setState({ loading: false });
        }
    };

    cambiarRutina = (rutinaId) => {
        const { hechas, noAplica } = avanceRutina(this.state.rutina);
        if (!hechas && !noAplica) return this.aplicarRutina(rutinaId);
        Modal.confirm({
            title: rutinaId ? "¿Cambiar de rutina?" : "¿Quitar la rutina?",
            content: "Se perderán los pasos marcados y los cambios hechos a la rutina en este servicio.",
            okText: "Sí",
            cancelText: "No",
            onOk: () => this.aplicarRutina(rutinaId),
        });
    };

    aplicarRutina = async (rutinaId) => {
        if (!rutinaId) return this.setState({ rutina: null });
        const res = await cmmsPost(this.props, "rutinaParaServicioCMMS", { rutinaId });
        if (res.data.success === 2) this.setState({ rutina: res.data.rutina });
        else message.error(res.data.message || "No se pudo cargar la rutina");
    };

    armarPayload = async (values) => {
        const iso = (v) => (v ? moment(v).toISOString() : null);
        const st = this.state;
        return {
            id: this.id,
            ...(st.borrador && !st.servicio ? { ticketId: st.borrador.ticketId, origen: st.borrador.origen, planServicioId: st.borrador.planServicioId } : {}),
            // Concluido + permiso: el backend aplica todo menos refacciones y equipo.
            edicionCompleta: !!(st.servicio?.estatus === 3 && st.edicionCompleta),
            activoId: values.activoId || st.servicio?.activoId || null,
            tipoServicio: values.tipoServicio,
            estatus: values.estatus,
            folioExterno: values.folioExterno,
            referencia: values.referencia,
            empleadoId: values.empleadoId || null,
            empleadosApoyoIds: values.empleadosApoyoIds || [],
            fechaProgramada: iso(values.fechaProgramada),
            fechaInicio: iso(values.fechaInicio),
            fechaConclusion: iso(values.fechaConclusion),
            duracionTrasladoMin: values.duracionTrasladoMin,
            lugar: values.lugar,
            responsableCliente: values.responsableCliente,
            ubicacion: values.ubicacion,
            area: values.area,
            condicionesRecepcion: { estatus: values.recepcionEstatus || null, texto: values.recepcionTexto || "" },
            condicionesEntrega: { estatus: values.entregaEstatus || null, texto: values.entregaTexto || "" },
            fallaReportada: values.fallaReportada,
            fallaEncontrada: values.fallaEncontrada,
            reporteTecnico: values.reporteTecnico,
            notas: values.notas,
            rutina: st.rutina,
            partes: st.partes,
            viaticos: (st.viaticos || []).map((v) => ({ _id: v._id, localId: v.localId || null, categoria: v.categoria, monto: Number(v.monto) || 0, descripcion: v.descripcion || "", empleadoId: v.empleadoId || null })),
            documentos: st.documentos.filter((d) => d.tipo && d.documentoId),
            montoTotal: values.montoTotal,
            aptoFacturacion: values.aptoFacturacion ? moment(values.aptoFacturacion).format("YYYY-MM") : "",
            fechaEnvioReporte: iso(values.fechaEnvioReporte),
            anexos: await anexosAPayload(values.anexos),
            // Los que habia al abrir: si la app sube fotos mientras tanto, el backend no las borra.
            anexosConocidos: (st.servicio?.anexos || []).map((a) => a._id).filter(Boolean),
            // Como estaba la Orden al abrirla: el backend solo aplica lo que se cambio aqui y conserva
            // lo que cambiaron en la app mientras tanto (si cambian lo mismo, gana lo mas reciente).
            base: st.servicio ? Object.fromEntries(CAMPOS_BASE_FUSION.map((c) => [c, st.servicio[c]])) : undefined,
        };
    };

    onFinish = async (values) => {
        const accion = this.accionPendiente;
        this.accionPendiente = null;
        this.setState({ loading: true });
        try {
            const payload = await this.armarPayload(values);
            const nuevo = !this.state.servicio;
            const res = await cmmsPost(this.props, nuevo ? "agregarServicioCMMS" : "editarServicioCMMS", payload);
            if (res.data.success !== 2) return message.error(res.data.message || "No se pudo guardar el servicio");
            this.avisarFusion(res.data.fusion);
            const id = nuevo ? res.data.codigo : this.id;
            if (accion === "concluir") {
                const r2 = await cmmsPost(this.props, "concluirServicioCMMS", { id });
                if (r2.data.success === 2) message.success("Servicio concluido: se actualizó el equipo y se descontaron las refacciones");
                else {
                    message.error(r2.data.message || "Se guardó, pero no se pudo concluir");
                }
            } else {
                message.success(nuevo ? `Servicio ${res.data.folio} registrado` : "Servicio guardado");
            }
            await this.consultar(id);
            if (nuevo) this.props.history.replace("/panel/cmmsServicio", { id });
        } catch (error) {
            console.log(error);
            message.error("No se pudo guardar el servicio");
        } finally {
            this.setState({ loading: false });
        }
    };

    // Lo que cambiaron en la app (u otra persona) mientras la Orden estaba abierta aqui ya se junto
    // al guardar; se avisa que se incorporo y, si se cambio lo mismo, que quedo lo mas reciente.
    avisarFusion = (fusion) => {
        const deOtros = fusion?.deOtros || [];
        const choques = fusion?.choques || [];
        if (!deOtros.length && !choques.length) return;
        Modal.info({
            title: "Se juntaron cambios hechos en otro lado",
            content: (
                <div>
                    {deOtros.length ? <p>Mientras tenía abierta la Orden se cambió desde la app u otra sesión: {deOtros.join(", ")}. Se conservó junto con lo que usted guardó.</p> : null}
                    {choques.length ? (
                        <p>
                            Se cambió lo mismo en los dos lados y quedó lo más reciente:{" "}
                            {choques.map((c) => `${c.etiqueta} (${c.gano === "este" ? "lo suyo" : "lo de la app u otra sesión"})`).join(", ")}. El valor que no quedó está en el historial de la Orden.
                        </p>
                    ) : null}
                </div>
            ),
            okText: "Entendido",
        });
    };

    onFinishFailed = (e) => {
        const campo = e?.errorFields?.[0]?.name?.[0];
        if (campo in PASO_DE_CAMPO) this.setState({ paso: Math.max(this.indicePaso(PASO_DE_CAMPO[campo]), 0) });
        ErrorItem(e);
    };

    concluir = () => {
        Modal.confirm({
            title: "¿Concluir el servicio?",
            content:
                "Se descontarán del almacén las refacciones marcadas, el equipo tomará la condición de entrega como su estatus y se recalculará su próximo preventivo. Después sólo podrá editar reporte, notas, viáticos, ventas y anexos.",
            okText: "Concluir",
            cancelText: "Cancelar",
            onOk: () => {
                this.accionPendiente = "concluir";
                this.formRef.current?.submit();
            },
        });
    };

    cancelarServicio = async () => {
        const motivo = (this.state.cancelar || "").trim();
        if (!motivo) return message.error("Escriba el motivo de la cancelación");
        this.setState({ loading: true });
        try {
            const res = await cmmsPost(this.props, "cancelarServicioCMMS", { id: this.id, motivo });
            if (res.data.success === 2) {
                message.success("Servicio cancelado");
                this.setState({ cancelar: null });
                await this.consultar(this.id);
            } else message.error(res.data.message || "No se pudo cancelar");
        } finally {
            this.setState({ loading: false });
        }
    };

    generarPdf = async () => {
        const res = await cmmsPost(this.props, "datosOrdenServicioPdfCMMS", { id: this.id });
        if (res.data.success !== 2) throw new Error(res.data.message || "No se pudieron consultar los datos");
        return ordenServicioCMMSPdf(await medirMarcaAgua(res.data.datos));
    };

    descargar = (key) => {
        if (key.startsWith("cert:")) {
            const c = this.state.certificados.find((x) => x._id === key.slice(5));
            if (c) this.setState({ pdfCertificado: c });
        } else if (["modalPdf", "modalVisita", "modalEtiqueta"].includes(key)) this.setState({ [key]: true });
    };

    // Concluido + permiso "Editar servicios concluidos": abre todos los campos (desde el aviso verde).
    editarConcluido = () =>
        Modal.confirm({
            title: "¿Editar el servicio concluido?",
            content:
                "Se abren todos los campos menos el equipo y las refacciones (ya salieron del almacén). Al guardar se recalculan las fechas y el estatus del equipo, y queda registrado en el historial.",
            okText: "Editar",
            cancelText: "Regresar",
            onOk: () => this.setState({ edicionCompleta: true }),
        });

    dejarDeEditar = async () => {
        this.setState({ loading: true });
        try {
            await this.consultar(this.id);
        } finally {
            this.setState({ loading: false });
        }
    };

    duracion = () => {
        const { fechaInicio, fechaConclusion } = this.state;
        if (!fechaInicio || !fechaConclusion) return "";
        const min = (new Date(fechaConclusion) - new Date(fechaInicio)) / 60000;
        return min > 0 ? minutosATexto(min) : "";
    };

    renderGeneral(bloqueado, concluido) {
        const s = this.state.servicio;
        // El equipo y el estatus de un concluido no se cambian ni con la edicion completa.
        const yaConcluido = this.estatus === 3;
        return (
            <DynamicCardForm title="General" xs={24} lg={14}>
                <FormItem label="Equipo" name="activoId" rules={[{ required: true, message: "Elija el equipo del servicio" }]} tooltip="Todo servicio es de un equipo. Si no existe, dé de alta el activo primero.">
                    <SelectActivoCMMS
                        empresaId={this.props.empresaId}
                        headersToken={this.props.headersToken}
                        disabled={yaConcluido || concluido || bloqueado}
                        textoInicial={this.state.activoTexto}
                        onChange={this.onChangeActivo}
                    />
                </FormItem>
                <Row gutter={12}>
                    <Col xs={24} md={12}>
                        <FormItem label="Tipo de servicio" name="tipoServicio" required>
                            <SelectItem placeholder="Tipo de servicio" disabled={concluido || bloqueado}>
                                {TIPOS_SERVICIO.map((t) => (
                                    <Option key={t.value} value={t.value}>
                                        {t.label}
                                    </Option>
                                ))}
                            </SelectItem>
                        </FormItem>
                    </Col>
                    <Col xs={24} md={12}>
                        <FormItem label="Estatus" name="estatus" tooltip="Programado: aún no se hace. En proceso: se está atendiendo. Para terminarlo use el botón Concluir.">
                            <SelectItem disabled={yaConcluido || concluido || bloqueado}>
                                <Option value={1}>Programado</Option>
                                <Option value={2}>En proceso</Option>
                            </SelectItem>
                        </FormItem>
                    </Col>
                    <Col xs={24} md={12}>
                        <FormItem label="Folio externo" name="folioExterno" max={60} tooltip="Folio del servicio en el sistema del cliente (ej. SER10000116013 de TINC).">
                            <InputItem placeholder="Opcional" disabled={bloqueado} />
                        </FormItem>
                    </Col>
                    <Col xs={24} md={12}>
                        <FormItem label="Referencia" name="referencia" max={200}>
                            <InputItem placeholder="Opcional" disabled={bloqueado} />
                        </FormItem>
                    </Col>
                </Row>
                {(() => {
                    // Contrato y vuelta: los del servicio guardado o los que trae el borrador.
                    const fuente = s || this.state.borrador || {};
                    return fuente.contratoNombre ? (
                        <div className="cmms-banda">
                            <div>
                                <b>Contrato {fuente.contratoNombre}</b>
                                {fuente.vueltaNombre ? ` · ${fuente.vueltaNombre}` : ""}
                                <div className="cmms-banda-secundaria">
                                    {fuente.planServicioId ? "Viene del programa del contrato: al concluir cuenta en su avance." : "Equipo de contrato: si es preventivo, al concluir se liga solo al programa de su vuelta."}
                                </div>
                            </div>
                        </div>
                    ) : null;
                })()}
                {(this.state.ticketCodigo || s) && (
                    <div className="cmms-ayuda" style={{ marginBottom: 0 }}>
                        {this.state.ticketCodigo ? `Viene del ticket ${this.state.ticketCodigo}. ` : ""}
                        {s ? `Origen: ${ORIGENES[s.origen] || "Manual"} · Creado ${formatoFechaHora(s.createdAt)}` : ""}
                    </div>
                )}
            </DynamicCardForm>
        );
    }

    renderAtencion(bloqueado, concluido) {
        return (
            <DynamicCardForm title="Atención" xs={24} lg={10}>
                <FormItem label="Ingeniero responsable" name="empleadoId" tooltip="Obligatorio para concluir.">
                    <SelectEmpleadosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} width="100%" placeholder="Ingeniero" disabled={concluido || bloqueado} />
                </FormItem>
                <FormItem label="Apoyo" name="empleadosApoyoIds">
                    <SelectEmpleadosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} width="100%" mode="multiple" placeholder="Opcional" disabled={concluido || bloqueado} />
                </FormItem>
                <Row gutter={12}>
                    <Col xs={12}>
                        <FormItem label="Inicio" name="fechaInicio">
                            <DatePicker showTime format="DD/MM/YYYY HH:mm" style={{ width: "100%" }} disabled={concluido || bloqueado} onChange={(v) => this.setState({ fechaInicio: v ? v.toISOString() : null })} />
                        </FormItem>
                    </Col>
                    <Col xs={12}>
                        <FormItem label="Término" name="fechaConclusion" tooltip="Si se deja vacía, se usa la hora en que se concluye.">
                            <DatePicker showTime format="DD/MM/YYYY HH:mm" style={{ width: "100%" }} disabled={concluido || bloqueado} onChange={(v) => this.setState({ fechaConclusion: v ? v.toISOString() : null })} />
                        </FormItem>
                    </Col>
                    <Col xs={12}>
                        <FormItem label="Duración del servicio">
                            <Input value={this.duracion() || "—"} disabled />
                        </FormItem>
                    </Col>
                    <Col xs={12}>
                        <FormItem label="Traslado (minutos)" name="duracionTrasladoMin">
                            <InputNumber min={0} style={{ width: "100%" }} placeholder="Opcional" disabled={concluido || bloqueado} />
                        </FormItem>
                    </Col>
                </Row>
                <FormItem label="Fecha programada" name="fechaProgramada">
                    <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} disabled={concluido || bloqueado} />
                </FormItem>
            </DynamicCardForm>
        );
    }

    renderEquipo(bloqueado, concluido) {
        const dis = concluido || bloqueado;
        return (
            <DynamicCardForm title="Lugar y condiciones del equipo" xs={24}>
                <Row gutter={12}>
                    <Col xs={24} md={8}>
                        <FormItem label="Lugar" name="lugar" max={200}>
                            <InputItem placeholder="Ej. Quirófano 2" disabled={dis} />
                        </FormItem>
                    </Col>
                    <Col xs={24} md={8}>
                        <FormItem label="Ubicación · Área" style={{ marginBottom: 0 }}>
                            <div style={{ display: "flex", gap: 6 }}>
                                <FormItem name="ubicacion" noStyle>
                                    <InputItem placeholder="Ubicación" disabled={dis} />
                                </FormItem>
                                <FormItem name="area" noStyle>
                                    <InputItem placeholder="Área" disabled={dis} />
                                </FormItem>
                            </div>
                        </FormItem>
                    </Col>
                    <Col xs={24} md={8}>
                        <FormItem label="Responsable del cliente" name="responsableCliente" max={200}>
                            <InputItem placeholder="Quién recibe el servicio" disabled={dis} />
                        </FormItem>
                    </Col>
                    <Col xs={24} lg={12}>
                        <FormItem label="Condición de recepción" name="recepcionEstatus">
                            <SelectorEstatusEquipo disabled={dis} />
                        </FormItem>
                        <FormItem name="recepcionTexto">
                            <InputItem placeholder="Detalle de cómo se recibió (opcional)" disabled={dis} />
                        </FormItem>
                    </Col>
                    <Col xs={24} lg={12}>
                        <FormItem
                            label="Condición de entrega"
                            name="entregaEstatus"
                            tooltip="Obligatoria para concluir: al concluir se vuelve el nuevo estatus del equipo."
                        >
                            <SelectorEstatusEquipo disabled={dis} />
                        </FormItem>
                        <FormItem name="entregaTexto">
                            <InputItem placeholder="Detalle de cómo se entrega (opcional)" disabled={dis} />
                        </FormItem>
                    </Col>
                </Row>
            </DynamicCardForm>
        );
    }

    renderReporte(bloqueado, concluido) {
        return (
            <DynamicCardForm title="Falla y reporte técnico" xs={24}>
                <Row gutter={12}>
                    <Col xs={24} md={12}>
                        <FormItem label="Falla reportada" name="fallaReportada">
                            <TextAreaItem rows={2} placeholder="Lo que reportó el cliente (viene del ticket)" disabled={concluido || bloqueado} />
                        </FormItem>
                    </Col>
                    <Col xs={24} md={12}>
                        <FormItem label="Falla encontrada" name="fallaEncontrada">
                            <TextAreaItem rows={2} placeholder="Lo que encontró el ingeniero" disabled={concluido || bloqueado} />
                        </FormItem>
                    </Col>
                    <Col xs={24}>
                        <FormItem label="Reporte técnico" name="reporteTecnico">
                            <TextAreaItem rows={3} placeholder="Qué se hizo" disabled={bloqueado} />
                        </FormItem>
                    </Col>
                    <Col xs={24}>
                        <FormItem label="Notas y recomendaciones" name="notas">
                            <TextAreaItem rows={2} placeholder="Opcional" disabled={bloqueado} />
                        </FormItem>
                    </Col>
                </Row>
            </DynamicCardForm>
        );
    }

    renderVentas(bloqueado) {
        const docs = this.state.documentos;
        const setDoc = (i, cambios) => this.setState({ documentos: docs.map((d, j) => (j === i ? { ...d, ...cambios } : d)) });
        return (
            <DynamicCardForm title="Ventas y facturación" xs={24} lg={12}>
                <div className="cmms-ayuda">Ligue la cotización, el pedido o la venta del ERP con que se cobra este servicio.</div>
                {docs.map((d, i) => (
                    <div key={i} style={{ display: "flex", gap: 6, marginBottom: 6 }}>
                        <Select value={d.tipo} disabled={bloqueado} style={{ width: 130 }} onChange={(tipo) => setDoc(i, { tipo, documentoId: null, texto: "" })}>
                            {DOCUMENTOS.map((t) => (
                                <Option key={t.value} value={t.value}>
                                    {t.label}
                                </Option>
                            ))}
                        </Select>
                        <div style={{ flex: 1, minWidth: 0 }}>
                            {d.documentoId && d.texto && !d.editando ? (
                                <Input value={d.texto} disabled={bloqueado} onFocus={() => setDoc(i, { editando: true })} readOnly />
                            ) : (
                                <SelectDocumentoItem
                                    tipo={d.tipo}
                                    empresaId={this.props.empresaId}
                                    headersToken={this.props.headersToken}
                                    value={d.documentoId || undefined}
                                    disabled={bloqueado}
                                    onChange={(documentoId, doc) => setDoc(i, { documentoId, texto: doc?.stringBuscar || "", editando: false })}
                                />
                            )}
                        </div>
                        {!bloqueado && <ButtonItem type="default" htmlType="button" rojo icon={<DeleteOutlined />} onClick={() => this.setState({ documentos: docs.filter((_, j) => j !== i) })} />}
                    </div>
                ))}
                {!bloqueado && (
                    <ButtonItem type="dashed" htmlType="button" icon={<PlusOutlined />} onClick={() => this.setState({ documentos: [...docs, { tipo: "Venta", documentoId: null, texto: "" }] })}>
                        Ligar documento
                    </ButtonItem>
                )}
                <Row gutter={12} style={{ marginTop: 10 }}>
                    <Col xs={12}>
                        <FormItem label="Monto del servicio" name="montoTotal" tooltip="Se usa en los indicadores de ingreso del equipo.">
                            <InputNumber min={0} style={{ width: "100%" }} placeholder="Opcional" disabled={bloqueado} formatter={(v) => (v ? `$ ${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "")} parser={(v) => v.replace(/\$\s?|(,*)/g, "")} />
                        </FormItem>
                    </Col>
                    <Col xs={12}>
                        <FormItem label="Mes apto para facturación" name="aptoFacturacion">
                            <DatePicker picker="month" format="MM/YYYY" style={{ width: "100%" }} disabled={bloqueado} />
                        </FormItem>
                    </Col>
                    <Col xs={12}>
                        <FormItem label="Envío del reporte" name="fechaEnvioReporte">
                            <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} disabled={bloqueado} />
                        </FormItem>
                    </Col>
                </Row>
            </DynamicCardForm>
        );
    }

    get pasos() {
        const { hechas, total, noAplica } = avanceRutina(this.state.rutina);
        const partes = this.state.partes.length;
        const viaticos = this.state.viaticos.length;
        const certificados = this.state.certificados.filter((c) => c.estatus === 1).length;
        const textoRefacciones = [partes ? `${partes} ${partes === 1 ? "partida" : "partidas"}` : "", viaticos ? `${viaticos} ${viaticos === 1 ? "viático" : "viáticos"}` : ""].filter(Boolean).join(" · ");
        return [
            { clave: "general", titulo: "General", descripcion: "Equipo y atención" },
            { clave: "diagnostico", titulo: "Diagnóstico", descripcion: "Condiciones y reporte" },
            { clave: "rutina", titulo: "Rutina", descripcion: total || noAplica ? `${hechas} de ${total} pasos${noAplica ? ` · ${noAplica} N/A` : ""}` : "Sin rutina" },
            { clave: "certificados", titulo: "Certificados", descripcion: certificados ? `${certificados} emitido${certificados === 1 ? "" : "s"}` : "Ninguno" },
            { clave: "refacciones", titulo: "Refacciones y viáticos", descripcion: textoRefacciones || "Ninguno" },
            { clave: "anexos", titulo: "Anexos y ventas", descripcion: "Evidencias y cobro" },
        ];
    }

    indicePaso = (clave) => this.pasos.findIndex((p) => p.clave === clave);

    renderPasos() {
        return (
            <div className="cmms-pasos">
                <Steps type="navigation" size="small" current={this.state.paso} onChange={(paso) => this.setState({ paso })}>
                    {this.pasos.map((p) => (
                        <Steps.Step key={p.titulo} title={p.titulo} description={p.descripcion} />
                    ))}
                </Steps>
            </div>
        );
    }

    // Todos los pasos se montan; sólo el actual se ve. Un paso oculto no se pinta.
    renderPaso(clave, contenido) {
        const indice = this.indicePaso(clave);
        if (indice < 0) return null;
        return (
            <div style={{ display: this.state.paso === indice ? "block" : "none" }}>
                <Row gutter={14}>{React.Children.toArray(contenido)}</Row>
            </div>
        );
    }

    renderNavegacion() {
        const { paso } = this.state;
        const ultimo = this.pasos.length - 1;
        const ir = (p) => this.setState({ paso: p }, () => window.scrollTo({ top: 0, behavior: "smooth" }));
        return (
            <div className="cmms-pasos-nav">
                <Button icon={<ArrowLeftOutlined />} disabled={paso === 0} onClick={() => ir(paso - 1)}>
                    Anterior
                </Button>
                <span style={{ color: "#7a8794", fontSize: 12 }}>
                    Paso {paso + 1} de {ultimo + 1}
                </span>
                {paso < ultimo ? (
                    <Button type="primary" onClick={() => ir(paso + 1)}>
                        Siguiente: {this.pasos[paso + 1].titulo} <ArrowRightOutlined />
                    </Button>
                ) : (
                    <span style={{ width: 90 }} />
                )}
            </div>
        );
    }

    renderRutina(bloqueado, concluido) {
        return (
            <DynamicCardForm
                title="Rutina"
                xs={24}
                headerRight={
                    !concluido && !bloqueado ? (
                        <Select
                            showSearch
                            allowClear
                            optionFilterProp="children"
                            placeholder="Usar una rutina del catálogo"
                            value={this.state.rutina?.rutinaId || undefined}
                            onChange={this.cambiarRutina}
                            style={{ width: 340 }}
                            size="small"
                        >
                            {this.state.rutinas.map((r) => (
                                <Option key={r._id} value={r._id}>
                                    {[r.codigo, r.titulo].filter(Boolean).join(" - ")}
                                </Option>
                            ))}
                        </Select>
                    ) : null
                }
            >
                {this.state.rutina?.titulo && <div style={{ fontWeight: 600, marginBottom: 8 }}>{[this.state.rutina.codigo, this.state.rutina.titulo].filter(Boolean).join(" · ")}</div>}
                <RutinaServicio value={this.state.rutina} onChange={(rutina) => this.setState({ rutina })} disabled={concluido || bloqueado} />
            </DynamicCardForm>
        );
    }

    renderAcciones(concluido, cancelado) {
        const s = this.state.servicio;
        const emitidos = this.state.certificados.filter((c) => c.estatus === 1);
        return (
            <div className="cmms-acciones">
                {s && (
                    <Dropdown
                        trigger={["click"]}
                        placement="bottomRight"
                        overlay={
                            <Menu onClick={({ key }) => this.descargar(key)}>
                                <Menu.ItemGroup title="Documentos">
                                    <Menu.Item key="modalPdf" icon={<FilePdfOutlined />}>
                                        Orden de Servicio
                                    </Menu.Item>
                                    <Menu.Item key="modalVisita" icon={<TeamOutlined />}>
                                        Reporte de visita del día
                                    </Menu.Item>
                                    {s.activoId && (
                                        <Menu.Item key="modalEtiqueta" icon={<QrcodeOutlined />}>
                                            Etiqueta del equipo
                                        </Menu.Item>
                                    )}
                                </Menu.ItemGroup>
                                <Menu.ItemGroup title="Certificados">
                                    {emitidos.length ? (
                                        emitidos.map((c) => (
                                            <Menu.Item key={`cert:${c._id}`} icon={<SafetyCertificateOutlined />}>
                                                {c.codigo} · {c.nombre}
                                            </Menu.Item>
                                        ))
                                    ) : (
                                        <Menu.Item key="sinCertificados" disabled icon={<SafetyCertificateOutlined />}>
                                            Sin certificados emitidos
                                        </Menu.Item>
                                    )}
                                </Menu.ItemGroup>
                            </Menu>
                        }
                    >
                        <ButtonItem blanco botonAncho lessTime icon={<DownloadOutlined />}>
                            Descargar <DownOutlined style={{ fontSize: 10, marginLeft: 6 }} />
                        </ButtonItem>
                    </Dropdown>
                )}
                {/* Fotos en cualquier momento (no hasta el paso Anexos): se elige de qué momento son. */}
                {!cancelado && (
                    <Dropdown
                        trigger={["click"]}
                        placement="bottomRight"
                        overlay={
                            <Menu>
                                <Menu.ItemGroup title="Agregar fotos o archivos de…">
                                    {ETIQUETAS_ANEXO.map((e) => (
                                        <Menu.Item key={e} icon={<CameraOutlined />}>
                                            <Upload multiple showUploadList={false} accept="image/*,.pdf" beforeUpload={(file) => this.agregarAnexo(file, e)}>
                                                <span style={{ display: "inline-block", minWidth: 150 }}>{e === "Antes" ? "Antes del servicio" : e === "Después" ? "Después del servicio" : e}</span>
                                            </Upload>
                                        </Menu.Item>
                                    ))}
                                </Menu.ItemGroup>
                                <Menu.Divider />
                                <Menu.Item key="ver" icon={<EyeOutlined />} onClick={() => this.setState({ paso: Math.max(this.indicePaso("anexos"), 0) })}>
                                    Ver los anexos
                                </Menu.Item>
                            </Menu>
                        }
                    >
                        <ButtonItem blanco botonAncho lessTime icon={<CameraOutlined />}>
                            Fotos <DownOutlined style={{ fontSize: 10, marginLeft: 6 }} />
                        </ButtonItem>
                    </Dropdown>
                )}
                {s && !cancelado && (
                    <ButtonItem rojoB botonAncho lessTime icon={<StopOutlined />} onClick={() => this.setState({ cancelar: "" })}>
                        Cancelar
                    </ButtonItem>
                )}
                {s && !cancelado && <span className="cmms-acciones-separador" />}
                {!cancelado && (
                    <ButtonItem cyan botonAncho icon={<SaveOutlined />} onClick={() => this.formRef.current?.submit()}>
                        Guardar
                    </ButtonItem>
                )}
                {!concluido && !cancelado && (
                    <ButtonItem verde botonAncho icon={<CheckCircleOutlined />} onClick={this.concluir}>
                        Concluir
                    </ButtonItem>
                )}
            </div>
        );
    }

    render() {
        const s = this.state.servicio;
        const yaConcluido = this.estatus === 3;
        const cancelado = this.estatus === 0;
        const bloqueado = cancelado;
        // Concluido = campos cerrados, salvo que se abrio la edicion completa (permiso).
        const concluido = yaConcluido && !this.state.edicionCompleta;
        const est = s ? estatusServicio(s.estatus) : null;

        return (
            <div className="cmms-pagina">
                <PageHeader
                    title={s ? `Servicio ${s.codigo}` : "Nuevo servicio"}
                    subTitle={est ? <Tag color={est.color}>{est.label}</Tag> : this.state.ticketCodigo ? `desde el ticket ${this.state.ticketCodigo}` : ""}
                    onBack={() => this.props.history.goBack()}
                    backIcon={<ArrowLeftOutlined />}
                    style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10, position: "sticky", top: 0, zIndex: 5 }}
                    extra={this.renderAcciones(yaConcluido, cancelado)}
                />
                {cancelado && <Alert type="error" showIcon style={{ marginBottom: 10 }} message={`Servicio cancelado: ${s.motivoCancelacion || ""}`} />}
                {yaConcluido && !this.state.edicionCompleta && (
                    <Alert
                        type="success"
                        showIcon
                        style={{ marginBottom: 10 }}
                        message={`Concluido ${formatoFechaHora(s.fechaConclusion)}. Sólo se pueden editar reporte técnico, notas, viáticos, ventas, anexos y certificados.`}
                        action={
                            this.state.puedeEditarConcluido ? (
                                <ButtonItem blanco size="small" lessTime icon={<EditOutlined />} onClick={this.editarConcluido}>
                                    Editar todo
                                </ButtonItem>
                            ) : null
                        }
                    />
                )}
                {s && !yaConcluido && !cancelado && s.terminadoEnSitio?.fecha && (
                    <Alert
                        type="info"
                        showIcon
                        style={{ marginBottom: 10 }}
                        message={`Terminada en sitio desde la app · ${formatoFechaHora(s.terminadoEnSitio.fecha)}`}
                        description="Revise lo que capturó el ingeniero, ajuste refacciones y almacén si hace falta, y dé Concluir."
                    />
                )}
                {yaConcluido && this.state.edicionCompleta && (
                    <Alert
                        type="warning"
                        showIcon
                        style={{ marginBottom: 10 }}
                        message="Editando un servicio concluido"
                        description="Puede cambiar todo menos el equipo y las refacciones. Al guardar se recalculan las fechas y el estatus del equipo."
                        action={
                            <ButtonItem blanco size="small" lessTime onClick={this.dejarDeEditar}>
                                Descartar cambios
                            </ButtonItem>
                        }
                    />
                )}
                <Spin spinning={this.state.loading}>
                    {/* Form de antd (no el de Items): ese ignora un segundo envio durante 5 s y aqui
                        es normal "Guardar" y enseguida "Guardar y concluir". Enter no envia. */}
                    <FormAntd
                        ref={this.formRef}
                        name="servicioCMMS"
                        layout="vertical"
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && e.target.type !== "textarea") e.preventDefault();
                        }}
                    >
                        <div className="cmms-pagina-cuerpo">
                            {this.renderPasos()}
                            {this.renderPaso("general", [this.renderGeneral(bloqueado, concluido), this.renderAtencion(bloqueado, concluido)])}
                            {this.renderPaso("diagnostico", [this.renderEquipo(bloqueado, concluido), this.renderReporte(bloqueado, concluido)])}
                            {this.renderPaso("rutina", this.renderRutina(bloqueado, concluido))}
                            {this.renderPaso(
                                "certificados",
                                <CertificadosServicio
                                    {...this.props}
                                    servicio={s}
                                    certificados={this.state.certificados}
                                    plantillas={this.state.plantillasCertificado}
                                    bloqueado={bloqueado}
                                    onCambio={() => this.cargarCertificados()}
                                />
                            )}
                            {this.renderPaso("refacciones", [
                                <DynamicCardForm title="Refacciones y consumibles" xs={24} key="partes">
                                    {yaConcluido && this.state.edicionCompleta && (
                                        <div className="cmms-ayuda">Las refacciones ya salieron del almacén: para cambiarlas cancele el servicio y haga uno nuevo.</div>
                                    )}
                                    <PartesServicio
                                        empresaId={this.props.empresaId}
                                        headersToken={this.props.headersToken}
                                        value={this.state.partes}
                                        onChange={(partes) => this.setState({ partes })}
                                        disabled={yaConcluido || bloqueado}
                                        concluido={yaConcluido}
                                    />
                                </DynamicCardForm>,
                                <DynamicCardForm title="Viáticos" xs={24} key="viaticos">
                                    <ViaticosServicio
                                        empresaId={this.props.empresaId}
                                        headersToken={this.props.headersToken}
                                        categorias={this.state.categoriasViatico}
                                        value={this.state.viaticos}
                                        onChange={(viaticos) => this.setState({ viaticos })}
                                        disabled={bloqueado}
                                    />
                                </DynamicCardForm>,
                            ])}
                            {this.renderPaso("anexos", [
                                <DynamicCardForm title="Anexos" xs={24} lg={12} key="anexos">
                                    <FormItem name="anexos" noStyle>
                                        <AnexosCMMS disabled={bloqueado} />
                                    </FormItem>
                                </DynamicCardForm>,
                                <React.Fragment key="ventas">{this.renderVentas(bloqueado)}</React.Fragment>,
                                s?.firmas?.length ? (
                                    <DynamicCardForm title="Firmas (app)" xs={24} lg={12} key="firmas">
                                        <div className="cmms-ayuda">Capturadas en sitio desde la app. Salen en la Orden de Servicio en PDF.</div>
                                        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                                            {s.firmas.map((f) => (
                                                <div key={f.rol} style={{ width: 200, textAlign: "center" }}>
                                                    <img src={`../${f.archivo?.url}`} alt={f.rol} style={{ width: "100%", height: 80, objectFit: "contain", border: "1px solid #e3e8ee", borderRadius: 6, background: "#fff" }} />
                                                    <div style={{ fontSize: 12, fontWeight: 600 }}>{f.nombre || "—"}</div>
                                                    <div style={{ fontSize: 11, color: "#7a8794" }}>{{ ingeniero: "Ingeniero de servicio", cliente: "Responsable área usuaria", biomedica: "Biomédica / Mantenimiento" }[f.rol] || f.rol}</div>
                                                </div>
                                            ))}
                                        </div>
                                    </DynamicCardForm>
                                ) : null,
                                s ? (
                                    <DynamicCardForm title="Historial" xs={24} key="historial">
                                        <Timeline>
                                            {(s.historialEstatus || []).map((h, i) => (
                                                <Timeline.Item key={i} color={estatusServicio(h.estatus).color === "default" ? "gray" : estatusServicio(h.estatus).color}>
                                                    <b>{h.estatusNombre}</b> · <span style={{ color: "#7a8794" }}>{formatoFechaHora(h.fecha)} · {h.usuarioNombre}</span>
                                                    {h.comentario ? <div style={{ fontSize: 12 }}>{h.comentario}</div> : null}
                                                </Timeline.Item>
                                            ))}
                                        </Timeline>
                                    </DynamicCardForm>
                                ) : null,
                            ])}
                            {this.renderNavegacion()}
                        </div>
                    </FormAntd>
                </Spin>

                <ModalFechasServicioCMMS
                    visible={this.state.pedirFechas}
                    inicio={this.state.fechaInicio}
                    termino={this.state.fechaConclusion}
                    onAceptar={this.aceptarFechas}
                    onMasTarde={() => this.setState({ pedirFechas: false })}
                />
                <ModalPdfCMMS
                    visible={this.state.modalPdf}
                    titulo={`Orden de Servicio ${s?.codigo || ""}`}
                    nombreArchivo={`OrdenServicio_${s?.codigo || ""}.pdf`}
                    generar={this.generarPdf}
                    onClose={() => this.setState({ modalPdf: false })}
                />
                <ModalReporteVisitaCMMS
                    {...this.props}
                    visible={this.state.modalVisita}
                    servicioId={this.id}
                    codigo={s?.codigo || ""}
                    onClose={() => this.setState({ modalVisita: false })}
                />
                <ModalPdfCMMS
                    visible={!!this.state.pdfCertificado}
                    titulo={`Certificado ${this.state.pdfCertificado?.codigo || ""}`}
                    nombreArchivo={`Certificado_${this.state.pdfCertificado?.codigo || ""}.pdf`}
                    generar={() => generarPdfCertificado(this.props, this.state.pdfCertificado._id)}
                    onClose={() => this.setState({ pdfCertificado: null })}
                />
                <ModalEtiquetasCMMS visible={this.state.modalEtiqueta} ids={s?.activoId ? [s.activoId] : []} onClose={() => this.setState({ modalEtiqueta: false })} />
                <Modal
                    visible={this.state.cancelar !== null}
                    title="Cancelar servicio"
                    onCancel={() => this.setState({ cancelar: null })}
                    onOk={this.cancelarServicio}
                    okText="Cancelar servicio"
                    cancelText="Regresar"
                    okButtonProps={{ danger: true }}
                >
                    {yaConcluido && (
                        <Alert
                            type="warning"
                            showIcon
                            style={{ marginBottom: 10 }}
                            message="El servicio está concluido: las refacciones que se descontaron regresarán al almacén y las fechas del equipo se recalcularán."
                        />
                    )}
                    <Input.TextArea rows={3} placeholder="Motivo de la cancelación (obligatorio)" value={this.state.cancelar || ""} onChange={(e) => this.setState({ cancelar: e.target.value })} />
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(Servicio);
